const ImageService = {
  uploadImages: async (images) => {
    const { data } = await ovpFetch('/image', {
      method: 'POST',
      body: images,
      defaultContentType: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { ImageService };
